import type { GridBlockV2Data } from "~/core";

export const isGridBlockV2 = (item: unknown): item is GridBlockV2Data => {
  return (
    typeof item === "object" &&
    item !== null &&
    "__typename" in item &&
    item.__typename === "grid_block_v2"
  );
};
